<section class="mt-2">
  <table class="table table-hover white_box shadow" style="margin-top: 10px;">
    <thead>
      <tr>
        <th scope="col">#</th>
        <th scope="col">Role</th>
        <th scope="col">User</th>
        <th scope="col">Organization</th>
        <th scope="col">Certified For</th>
        <th scope="col">File</th>
        <th scope="col">Status</th>
        <th scope="col" class="text-center">Action</th>
      </tr>
    </thead>
    <tbody>
      <tr *ngFor="let item of certificates; let i = index;">
        <th scope="row">{{i + 1}}</th>
        <td>
          {{ item.role }}
        </td>
        <td>
          {{ item.appUser?.profileCharacterName }}
        </td>
        <td>
          {{ item.organization }}
        </td>
        <td>
          {{ item.certifiedFor }}
        </td>
        <td>
          <a href="{{ imgUrl }}{{ item.file }}" target="_blank">Check File</a>
        </td>
        <td>
          <select class="form-control" (change)="handleApproval($event, item)">
            <option *ngFor="let status of listStatus; let i = index" [value]="i" [selected]="item.status == i">{{ status
              }}</option>
          </select>
        </td>
        <td>
          <div class="btn-group">
            <button class="btn btn-sm btn-danger" (click)="handleDelete(item)">
              <i class="fa-solid fa-trash"></i>
            </button>
          </div>
        </td>
      </tr>
    </tbody>
  </table>
</section>

<!-- <ng-template #addEditCategory let-modal>
  <div class="modal-header">
      <h4 class="modal-title">Add/editCategory</h4>
      <a (click)="modal.dismiss('Cross click')"><i class="fa fa-window-close" aria-hidden="true"></i></a>
  </div>
  <div class="modal-body">
      <div class="row">
          <div class="form-group col-12">
              <label for="exampleInputEmail1">Category Name </label>
              <input type="text" [(ngModel)]="categoryName" class="form-control" placeholder="Enter Category Name">
          </div>
      </div>


      <duv class="d-flex justify-content-end">
          <button type="button" class="btn btn-secondary" (click)="AddEditCategorySubmit()">
              Save
          </button>
      </duv>
  </div>
</ng-template> -->